export interface AmountConfig {
    element: HTMLElement,
    min: number,
    max: number
}

export class Amount {
    public readonly buttons: {
        add: HTMLElement,
        subtract: HTMLElement
    };
    private readonly value: HTMLElement;
    public min: number;
    public max: number;

    constructor({element, min, max}: AmountConfig) {
        this.buttons = {
            add: element.querySelector(`[data-action=add]`),
            subtract: element.querySelector(`[data-action=subtract]`)
        };
        this.value = element.querySelector(`[data-value]`);
        this.min = min;
        this.max = max;
    }

    public setButtonState(button: HTMLElement, enable: Boolean): void {
        enable
            ? button.classList.remove(`is-disabled`)
            : button.classList.add(`is-disabled`);
    }

    public save(value: string): void {
        this.value.textContent = value;
    }

    public update(value: string) {
        this.save(value);

        if (+value <= this.min) {
            this.setButtonState(this.buttons.subtract, false);
        } else if (+value >= this.max) {
            this.setButtonState(this.buttons.add, false);
        } else {
            Object.values(this.buttons).forEach(button => {
                this.setButtonState(button, true);
            });
        }
    }
}